/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as i0 from '@angular/core';
import * as i1 from '../../../../angularApp/app/forbidden/forbidden.component';
const styles_ForbiddenComponent:any[] = ([] as any[]);
export const RenderType_ForbiddenComponent:i0.RendererType2 = i0.ɵcrt({encapsulation:2,
    styles:styles_ForbiddenComponent,data:{}});
export function View_ForbiddenComponent_0(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵeld(0,(null as any),(null as any),1,'div',([] as any[]),
      (null as any),(null as any),(null as any),(null as any),(null as any))),(_l()(),
      i0.ɵted((null as any),['403: You have no rights to access this.']))],(null as any),
      (null as any));
}
export function View_ForbiddenComponent_Host_0(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵeld(0,(null as any),(null as any),1,'forbidden',([] as any[]),
      (null as any),(null as any),(null as any),View_ForbiddenComponent_0,RenderType_ForbiddenComponent)),
      i0.ɵdid(114688,(null as any),0,i1.ForbiddenComponent,([] as any[]),(null as any),
          (null as any))],(_ck,_v) => {
    _ck(_v,1,0);
  },(null as any));
}
export const ForbiddenComponentNgFactory:i0.ComponentFactory<i1.ForbiddenComponent> = i0.ɵccf('forbidden',
    i1.ForbiddenComponent,View_ForbiddenComponent_Host_0,{},{},([] as any[]));
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiQzovQml0YnVja2V0X1JlcG9zL3JhZGlvbmV0X21hbmFnZW1lbnRfY2xpZW50L1JhZGlvTmV0TWFuYWdlbWVudENsaWVudC9hbmd1bGFyQXBwL2FwcC9mb3JiaWRkZW4vZm9yYmlkZGVuLmNvbXBvbmVudC5uZ2ZhY3RvcnkudHMiLCJ2ZXJzaW9uIjozLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJuZzovLy9DOi9CaXRidWNrZXRfUmVwb3MvcmFkaW9uZXRfbWFuYWdlbWVudF9jbGllbnQvUmFkaW9OZXRNYW5hZ2VtZW50Q2xpZW50L2FuZ3VsYXJBcHAvYXBwL2ZvcmJpZGRlbi9mb3JiaWRkZW4uY29tcG9uZW50LnRzIiwibmc6Ly8vQzovQml0YnVja2V0X1JlcG9zL3JhZGlvbmV0X21hbmFnZW1lbnRfY2xpZW50L1JhZGlvTmV0TWFuYWdlbWVudENsaWVudC9hbmd1bGFyQXBwL2FwcC9mb3JiaWRkZW4vZm9yYmlkZGVuLmNvbXBvbmVudC5odG1sIiwibmc6Ly8vQzovQml0YnVja2V0X1JlcG9zL3JhZGlvbmV0X21hbmFnZW1lbnRfY2xpZW50L1JhZGlvTmV0TWFuYWdlbWVudENsaWVudC9hbmd1bGFyQXBwL2FwcC9mb3JiaWRkZW4vZm9yYmlkZGVuLmNvbXBvbmVudC50cy5Gb3JiaWRkZW5Db21wb25lbnRfSG9zdC5odG1sIl0sInNvdXJjZXNDb250ZW50IjpbIiAiLCI8ZGl2PjQwMzogWW91IGhhdmUgbm8gcmlnaHRzIHRvIGFjY2VzcyB0aGlzLjwvZGl2PiIsIjxmb3JiaWRkZW4+PC9mb3JiaWRkZW4+Il0sIm1hcHBpbmdzIjoiQUFBQTs7Ozs7Ozs7Ozs7Ozs7b0JDQUE7TUFBQSx3RUFBSzthQUFBOzs7O29CQ0FMO01BQUE7YUFBQTtVQUFBO0lBQUE7Ozs7In0=



// WEBPACK FOOTER //
// ./aot/angularApp/app/forbidden/forbidden.component.ngfactory.ts